import { getQueryData } from '../../api/helpers'
import { projectResponseFields } from '../../common/response/project'
import { findEntityTitle, generateLocationData } from '../../utils/general'
import { AsyncSelectOption, PageListParams } from '../globalTypes'
import { Property, PropertyData } from './types'

export const formatPropertyAsyncOption = (item: Property): AsyncSelectOption => {
    const currentLang = localStorage.getItem('i18nextLng') ?? 'hr'
    const title = item.translations?.[currentLang]?.propertyTitle ?? generateLocationData(item)

    return {
        value: item.id as number,
        label: `ID: ${item.internalAppId} - ${title}`,
        location: generateLocationData(item),
    }
}

// used in PropertyEdit for project field (connect property to project)
export const formatPropertyProjectOptions = (id?: string | number) => {
    if (!id) return []

    const data = getQueryData<PropertyData>(['properties', id])

    if (!data) return []
    const { item } = data
    const project = item?.project
    const projectId = project?.id

    if (!project || !projectId) return []

    return [
        {
            label: `ID: ${project.internalAppId} - ${findEntityTitle(project, projectResponseFields.PROJECT_TITLE)}`,
            value: projectId.toString(),
        },
    ]
}

// used for activity modal in property
export const formatPropertyOptionById = (id?: string | number, params?: PageListParams) => {
    const data = getQueryData<PropertyData>(['properties', id], params)
    const currentLang = localStorage.getItem('i18nextLng') ?? 'hr'

    if (!data) return []
    const { item } = data

    const option = {
        value: item?.id?.toString(),
        label: `ID: ${item?.internalAppId} - ${item?.translations?.[currentLang]?.propertyTitle ?? generateLocationData(item)}`,
        location: generateLocationData(item),
    }

    return [option]
}
